export const DEFAULT_PREP_TIME = 15;
//# sourceMappingURL=DefaultPrepTime.js.map